import { Navigate, useLocation } from "react-router-dom";

// Sin esto `/en` cae en el comodin y lleva a la portada en espanol. El search son los utm del QR.
export default function EnglishRedirect() {
    const { search } = useLocation();
    return <Navigate to={{ pathname: "/en/advisors", search }} replace />;
}
